import { readStorageItem, updateStorageItem } from '#utils/storage/index.ts';

const MAGIC_AUTH_EMAIL_KEY = 'cascade.auth.magic_auth_email';

export const readMagicAuthEmail = (): string | undefined =>
  readStorageItem(MAGIC_AUTH_EMAIL_KEY);

export const rememberMagicAuthEmail = (email?: string): void =>
  updateStorageItem(MAGIC_AUTH_EMAIL_KEY, email);
